export default __webpack_public_path__ + "static/media/shikma1.9ed1c0e4.jpg";